// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__16fQj","inputWrap":"Table_inputWrap__16lnF","col":"Table_col__3YvGi","bmiTooltip":"Table_bmiTooltip__3pTCx"};